﻿(function (angular, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Factories").factory("DealerInventoryService", [
    "$filter",
    "API",
    "UrlParser",
    "DealerSelector",
    "DebugLogger",
    function ($filter, API, UrlParser, DealerSelector, DebugLogger) {
      return {
        get: function (dealerObject, materialCode) {
          var isUsingLegacy = DealerSelector.getIsUsingLegacy();
          var branchCode = isUsingLegacy
            ? dealerObject.sapDealerCode
            : dealerObject.branchCode;
          var branchCodeResolutionStrategy = isUsingLegacy ? "(using sapDealerCode)" : "(using branchCode)";
          DebugLogger.log("DealerInventoryService", "Resolved branchCode to: ", branchCode, branchCodeResolutionStrategy);
          var dealerInventoryURL = $filter("formatArgs")(ToyotaConsts.API.Vehicle.DealerStock, [
            branchCode,
            materialCode,
          ]);
          return API.get(dealerInventoryURL);
        },
        cancel: API.cancel,
        urlWithCampaignTracking: function (url, utmMedium, utmTerm) {
          var newAttributes = {
            utm_source: "toyota_com_au",
            utm_medium: utmMedium,
            utm_campaign: "dealer_integration",
            utm_term: utmTerm,
            utm_content: window.location.href,
          };
          return UrlParser.overrideUrlQueryStringFromMap(url, newAttributes);
        },
      };
    },
  ]);
})(window.angular, window.ToyotaConsts);
